"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoCall/Feedback/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _RatingMeter = require('web/components/VideoCall/Feedback/RatingMeter'); var _RatingMeter2 = _interopRequireDefault(_RatingMeter);
var _withFeedbackController = require('web/screens/VideoCall/Feedback/withFeedbackController'); var _withFeedbackController2 = _interopRequireDefault(_withFeedbackController);
var _Modals = require('web/components/VideoCall/Feedback/Modals');


var _helpers = require('web/components/VideoCall/Feedback/helpers');








// Was a PureComponent: memo keeps the shallow props bail-out.
const Feedback = _react.memo.call(void 0, function Feedback ({
  lowRatingReasons,
  isRatingSubmitted,
  isSubmittedRatingLow,
  submitRating,
  submitLowRatingReason,
  submitLowRatingComment,
  sessionDuration,
}) {
  const [currentRating, setCurrentRating] = _react.useState.call(void 0, 0)
  const [isLowRatingReasonModalOpen, setIsLowRatingReasonModalOpen] = _react.useState.call(void 0, false)

  const handleRatingUpdate = (n) => !isRatingSubmitted &&
    setCurrentRating(n)

  // Stable: the reason modal is memoized.
  const closeLowRatingReasonModal = _react.useCallback.call(void 0, 
    () => setIsLowRatingReasonModalOpen(false),
    [],
  )

  // Returns the promise, which rejects for a low rating, as the class did.
  const handleProceed = () => submitRating(currentRating)

  // componentDidUpdate: open the reason modal when a submitted rating turns
  // out low (never on mount).
  const wasSubmittedRatingLow = _react.useRef.call(void 0, isSubmittedRatingLow)
  _react.useLayoutEffect.call(void 0, () => {
    const wasLow = wasSubmittedRatingLow.current
    wasSubmittedRatingLow.current = isSubmittedRatingLow
    if (!wasLow && isSubmittedRatingLow) setIsLowRatingReasonModalOpen(true)
  }, [isSubmittedRatingLow])

  const noteClassName = _classBuilder2.default.call(void 0, 
    "meeting--feedback--note",
    { hidden: !isRatingSubmitted },
  )
  const proceedBtnClassName = _classBuilder2.default.call(void 0, 
    "meeting--btn",
    "meeting--feedback--proceed-btn",
    { disabled: currentRating === 0 },
    { hidden: isRatingSubmitted },
  )

  return (
    _react2.default.createElement('div', { className: "meeting--feedback", __self: this, __source: {fileName: _jsxFileName, lineNumber: 64}}
      , _react2.default.createElement('div', { className: "meeting--feedback--content", __self: this, __source: {fileName: _jsxFileName, lineNumber: 65}}
        , _react2.default.createElement('div', { className: "meeting--feedback--title-wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 66}}
          , _react2.default.createElement('h3', { className: "meeting--feedback--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 67}}, "Call finished" )
          , _react2.default.createElement('span', { className: "meeting--feedback--call-duration", __self: this, __source: {fileName: _jsxFileName, lineNumber: 68}}
            ,  _helpers.formatSessionDuration.call(void 0, sessionDuration) 
          )
        )
        , _react2.default.createElement('div', { className: "meeting--feedback--rating-wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 72}}
          , _react2.default.createElement('h4', { className: "meeting--feedback--rating-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 73}}, "How was your call?"   )
          , _react2.default.createElement(_RatingMeter2.default, {
            currentRating: currentRating,
            onRatingUpdate: handleRatingUpdate,
            onRatingSubmit: submitRating,
            isSubmitted: isRatingSubmitted,
            className: "meeting--feedback--stars-wrapper",
            itemClassName: "meeting--feedback--star", __self: this, __source: {fileName: _jsxFileName, lineNumber: 74}}
          )
          , _react2.default.createElement('span', { className: noteClassName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 82}}, "Your feedback was submitted."

          )
          , _react2.default.createElement('div', { className: "meeting--feedback--buttons-wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 85}}
            , _react2.default.createElement('a', { className: proceedBtnClassName, onClick: handleProceed, __self: this, __source: {fileName: _jsxFileName, lineNumber: 86}}, "Rate call"

            )
          )
        )
        , _react2.default.createElement(_Modals.LowRatingReasonModal, {
          isOpen: isLowRatingReasonModalOpen,
          onClose: closeLowRatingReasonModal,
          onReasonSubmit: submitLowRatingReason,
          onCommentSubmit: submitLowRatingComment,
          lowRatingReasons: lowRatingReasons, __self: this, __source: {fileName: _jsxFileName, lineNumber: 91}}
        )
      )
    )
  )
})

exports. default = _withFeedbackController2.default.call(void 0, Feedback)
